import React from 'react';
import dynamic from 'next/dynamic';

const CustomLandingPage = dynamic(() => import('../js/pages/CustomLandingPage'));
const Page = () => <CustomLandingPage id="INTERACTION_DESIGNER" />;

export default Page;
